import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Actions } from '../actions';
import { getIsMobileDrawerOpen, getMobileMenuType } from '../selectors';
import NavBarMobile from '../components/NavBarMobile';

export const NavBarMobileContainer: React.FC = () => {
  const currentMenu = useSelector(getMobileMenuType);
  const isDrawerOpen = useSelector(getIsMobileDrawerOpen);

  const dispatch = useDispatch();
  const openDrawer = React.useCallback(() => {
    dispatch(Actions.openMobileDrawer());
  }, []);
  const closeDrawer = React.useCallback(() => {
    dispatch(Actions.closeMobileDrawer());
  }, []);

  const props = {
    currentMenu,
    isDrawerOpen,
    openDrawer,
    closeDrawer,
  };

  return <NavBarMobile {...props} />;
};

export default NavBarMobileContainer;
